import React from 'react'
import { useSelector } from 'react-redux'
import DashboardSingleListShareholdersTableRowData from './table-row'
import EmptyTableView from '../../../../../universal/empty-table'
import { TableLoader } from '../../../../../library/table-loader'
import './style.scss'

const Index = () => {

	const shareholders = useSelector(state => state.singleList.activeDisplay.general.shareholders)
    const loading = useSelector(state => state.singleList.fetchSingleDetails.loading)

    const renderEmptyView = () => {
		if(!loading){
			if(shareholders && shareholders.length === 0 || !shareholders){
				return <EmptyTableView title="Ingen aksjonærer tilgjengelig" description="Jøss, det var rart! Det ser ikke ut som det er noen aksjonærer tilgjengelig å vise for denne virksomheten."/>
			}
			return null
		}
		return null
	}

	return(
		<div className="single-client-shareholders-tab-container">
			<div className="tab-content-container">
				<div className="full-shareholders-container">
					<table>
						<tr>
                            <th>Navn</th>
                            <th>Organisasjonsnummer</th>
                            <th>Land</th>
                            <th>Andel</th>
						</tr>
						{shareholders && shareholders.map((shareholder, index, arr) => {
							return(
								<DashboardSingleListShareholdersTableRowData shareholder={shareholder} last={index === (arr.length - 1) ? true:false}/>
							)
						})}
					</table>
				</div>
                {loading ? <TableLoader/>:null}
			    {renderEmptyView()}
			</div>
		</div>
	)
}

export default Index


